import React from 'react';
import { UrgencyBar } from '../components/UrgencyBar';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { RevelationSection } from '../components/RevelationSection';
import { BonusPreviews } from '../components/BonusPreviews';
import { OfferSection } from '../components/OfferSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FAQSection } from '../components/FAQSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { SocialProofPopup } from '../components/SocialProofPopup';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="w-full min-h-screen bg-bg-primary" data-id="element-389">
      <UrgencyBar data-id="element-390" />
      <SocialProofPopup data-id="element-391" />
      <main data-id="element-392">
        <HeroSection data-id="element-393" />
        <PainSection data-id="element-394" />
        <RevelationSection data-id="element-395" />
        <BonusPreviews data-id="element-396" />
        <OfferSection data-id="element-397" />
        <TestimonialsSection data-id="element-398" />
        <FAQSection data-id="element-399" />
        <GuaranteeSection data-id="element-400" />
      </main>
      <Footer data-id="element-401" />
    </div>;
}